import SendEventAPI from "../../api/send-event.api";
import { getBaseEvent } from "./getBaseEvent";
import { pushTrackingToKenisis } from "./pushTrackingToKenisis";

export function trackEvents(event_name: any, event_type: any, payload: any) {
  if (window.showLogs) {
    console.log("track event data: ", event_name, event_type, payload);
  }

  if (!window.trackingDataLayer) {
    window.trackingDataLayer = [];
    pushTrackingToKenisis();
  }

  const record = {
    ...getBaseEvent(event_name, event_type),
    payload,
  };

  window.trackingDataLayer.push(record);

  // send events once we collect 20 events.

  if (window.trackingDataLayer.length >= 20) {
    SendEventAPI.sendEventWithPayload(window.trackingDataLayer);

    window.trackingDataLayer = [];
  }
}
